import { egresadosApiCall } from "../../../../axios/apiClient"; 

const controller = `rangoSalarial`;

export default {
    getRangoSalarial: async () => {
        let response = { success: true };
        const method = "";
        try{
            const apiResponse = await egresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        }
        catch(error){
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    }
}
